import { FC, useState } from "react";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { White } from "capitalrx-components-2.0/lib/general/Color";
import { Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Semibold } from "capitalrx-components-2.0/lib/typography";

import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";

import { FeedbackModal } from "./FeedbackModal";
import styles from "./FeedbackButton.module.scss";

export const FeedbackButton: FC = () => {
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const [showModalValue, setShowModalValue] = useState(false);

  const handleModal = (): void => {
    setShowModalValue(!showModalValue);
  };

  return (
    <div className={isCompressed ? styles.feedbackContainerMobile : styles.feedbackContainer}>
      <button className={styles.feedbackButton} onClick={() => handleModal()} >
        <Shelf spacing="small">
          <Icon color={White} name="message-dots" />
          <Semibold style={{ color: "#FFFFFF" }}>Feedback</Semibold>
        </Shelf>
      </button>
      <FeedbackModal handleModal={handleModal} isModalOpen={showModalValue} />
    </div>
  );
};
